<template>
  <div class="teachingActivities">
    <el-button size="small" type="primary" @click="addCurriculum" icon="el-icon-plus">添加平台活动</el-button>
    <el-form class="form-style" :inline="true" size="small">
      <el-form-item label="活动名称:">
        <el-input v-model="title" clearable placeholder="请输入活动名称"></el-input>
      </el-form-item>
      <el-form-item label="活动类型:">
        <el-select v-model="activity_type_id" clearable placeholder="请选择活动类型">
          <el-option
            v-for="item in activity_type"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="置顶等级:">
        <el-select v-model="new_state" clearable placeholder="请选择置顶等级">
          <el-option label="全部" value></el-option>
          <el-option label="置顶" value="1"></el-option>
          <el-option label="不置顶" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="table-style">
      <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>

        <el-table-column align="center" width="100" label="封面">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 18px" :src="scope.row.img_url" fit="fill"></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="title" label="标题" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="new_state" label="等级"></el-table-column>
        <el-table-column align="center" label="报名人数">
          <template slot-scope="scope">
            <el-link class="num" @click="uPactivityList(scope.row)">{{scope.row.tch_num}}</el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" label="群图片">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 18px" :src="scope.row.group_img_url" fit="fill"></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="activity_date" label="时间" show-overflow-tooltip></el-table-column>
        <el-table-column
          align="center"
          prop="runActivityTypeName"
          label="活动类型"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column align="center" label="操作" width="300px">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="editbtn(scope.row)">修改</el-button>
            <el-button size="small" type="text" @click="zhiding(scope.row)">置顶等级</el-button>

            <el-button size="small" type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page_no"
        layout="total, prev, pager, next"
        :total="total"
        :page-size="20"
      ></el-pagination>
    </div>

    <!-- 是否置顶弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="30%">
      <el-form ref="form" :model="formGad" label-width="80px">
        <el-form-item label="置顶等级">
          <el-select v-model="formGad.new_state" placeholder="请选择">
            <el-option
              v-for="item in newState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="isTopping">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 获取弹窗列表 -->
    <el-dialog title="观看信息" :visible.sync="dialogVisible2">
      <el-table :data="tableDataDialog2" style="width: 100%" height="500">
        <el-table-column prop="created_time" label="观看日期"></el-table-column>
        <el-table-column prop="schoolName" label="校区"></el-table-column>
        <el-table-column label="姓名" prop="created_time">
          <template slot-scope="scope">{{scope.row.userInfo.realname}}</template>
        </el-table-column>
        <el-table-column label="电话">
          <template slot-scope="scope">{{scope.row.userInfo.phone_num}}</template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination
          @current-change="handleCurrent"
          :current-page="page1_no"
          :page-size="page1_size"
          layout="total, prev, pager, next"
          :total="total1"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import {
//   activityList,
//   //   getAdminSubjectList,
//   isTopping,
//   del,
//   tchList
// } from "@/api/admin.js";
import {
  activityList,
  topActivity,
  delActivity,
  typeList,
  uPactivityList
} from "@/api/operationalActivities.js";

export default {
  name: "teachingActivities",

  data() {
    return {
      user: {},
      activity_type: [],
      new_state: "",

      tableDataDialog2: [],
      run_activity_id: "",
      formGad: {
        new_state: "",
        run_activity_id: ""
      },
      dialogVisible1: false,
      dialogVisible2: false,

      total1: 0,
      page1_no: 1,
      page1_size: 20,
      //课程封面
      newState: [
        {
          value: "0",
          label: "不置顶"
        },
        {
          value: "1",
          label: "1级"
        },
        {
          value: "2",
          label: "2级"
        },
        {
          value: "3",
          label: "3级"
        },
        {
          value: "4",
          label: "4级"
        },

        {
          value: "5",
          label: "5级"
        },
        {
          value: "6",
          label: "6级"
        }
      ],

      // subjectList: [],
      startDate: "",
      endDate: "",
      title: "",
      activity_type_id: "",
      total: 0,
      page_no: 1,
      research: "",
      subjectId: "",
      fileList: [],
      fileListqun: [],
      form: {
        subject_id: "", //所属科目
        title: "", //标题
        activity_type: "", //活动类型
        activity_date: "", //活动日期
        brief_content: "", //简要介绍
        new_state: "", //置顶等级
        notice_content: "", //通知内容
        main_content: "", //活动介绍，
        tch_question_content: "", //教师提问
        video_url: "" //视频地址
      },
      tableData: [],
      rules: {
        host: [
          {
            required: true,
            message: "请输入主持人"
          }
        ],
        startDate: [
          {
            required: true,
            type: "date",
            message: "请选择开始时间",
            trigger: "change"
          }
        ],
        endDate: [
          {
            required: true,
            type: "date",
            message: "请选择结束时间",
            trigger: "change"
          }
        ],
        subject_id: [
          {
            required: true,
            message: "请选择科目"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入标题"
          }
        ],
        activity_type: [
          {
            required: true,
            message: "请选择活动类型"
          }
        ],
        activity_date: [
          {
            required: true,
            message: "请选择活动日期"
          }
        ],
        brief_content: [
          {
            required: true,
            message: "请输入简要介绍"
          }
        ],
        new_state: [
          {
            required: true,
            message: "请选择置顶等级"
          }
        ],
        notice_content: [
          {
            required: true,
            message: "请输入通知内容"
          }
        ],
        main_content: [
          {
            required: true,
            message: "请输入活动介绍"
          }
        ]
      }
    };
  },
  mounted() {
    // this.getAdminSubjectList();
    this.activityList();
    this.typeList();
  },
  methods: {
    //获取活动类型列表
    typeList() {
      typeList({}).then(res => {
        this.activity_type = res.runActivityTypeList;
        this.total = res.total;
      });
    },

    handleCurrent(val) {
      this.page1_no = val;
      uPactivityList({
        run_activity_id: this.research,
        page_no: this.page1_no,
        page_size: this.page1_size
      }).then(res => {
        console.log(res);
        this.tableDataDialog2 = res.RunActivityTchList;
        this.total1 = res.total;
      });
    },

    // //获取观看信息
    uPactivityList(row) {
      this.dialogVisible2 = true;
      uPactivityList({
        run_activity_id: row.id,
        page_no: this.page1_no,
        page_size: this.page1_size
      }).then(res => {
        console.log(res);
        this.tableDataDialog2 = res.RunActivityTchList;
        this.total1 = res.total;
        let a = row.id;
        this.research = a;
      });
    },

    //编辑
    editbtn(row) {
      this.$router.push({
        name: "addBasicMaterialOperational",
        query: {
          row: JSON.stringify(row)
        }
      });

      console.log(row);
      console.log(this.fileList);
      this.fileList = [];
      this.fileListqun = [];

      this.fileList.push({
        url: row.img_url
      });
      this.fileListqun.push({
        url: row.group_img_url
      });

      this.form = row;
      // let end = "";
      this.run_activity_id = row.id;
      this.dialogVisible = true;
    },
    //是否置顶弹窗
    zhiding(row) {
      this.dialogVisible1 = true;
      console.log(row.id, "测试");
      this.formGad.run_activity_id = row.id;
    },

    //获取科目
    // getAdminSubjectList() {
    //   getAdminSubjectList().then(res => {
    //     console.log(res);
    //     this.subjectList = res.subject_list;
    //   });
    // },
    search() {
      this.activityList();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.activityList();
    },
    addCurriculum() {
      this.$router.push({
        name: "addBasicMaterialOperational",
        query: {
          act: "add"
        }
      });
    },

    //是否置顶
    isTopping() {
      topActivity(
        {
          run_activity_id: this.formGad.run_activity_id,
          new_state: this.formGad.new_state
        },
        true
      ).then(() => {
        this.dialogVisible1 = false;
        this.$message.success("置顶成功");
        this.activityList();
      });
    },

    del(row) {
      this.$confirm("确定删除当前活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delActivity(
          {
            run_activity_id: row.id
          },
          true
        ).then(() => {
          this.$message.success("删除成功！");
          this.activityList();
        });
      });
    },
    //获取列表
    activityList() {
      activityList({
        title: this.title,
        new_state: this.new_state,
        activity_type_id: this.activity_type_id,
        page_no: this.page_no,
        page_size: 20
      }).then(res => {
        console.log("平台科目");
        console.log(res);
        this.tableData = res.runActivityList;
        this.total = res.total;
      });
    }
  }
};
</script>



<style scoped lang="scss">
.time {
  overflow: hidden;
}
.fl {
  float: left;
}
.teachingActivities {
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 10px;
  padding: 15px;
  border-radius: 5px;
  .form-style {
    margin-left: 15px;
  }
  .table-style {
    margin-top: 15px;
  }
}
.num {
  cursor: pointer;
}
</style>
